import appEvents from 'App/appEvents';

export const notify = (newToast: ToastElement) => {
  appEvents.emit('NOTIFY', newToast);
};
